const PriceLevel = [
    {id: "0", value: "便宜價以下"},    
    {id: "1", value: "便宜價至合理價之間"},
    {id: "2", value: "合理價至昂貴價之間"},
    {id: "3", value: "昂貴價以上"},        
  ];  
  
  export default PriceLevel  